import classNames from 'classnames'

import { OrderDetailsType } from '../../../api/services/orders/types.ts'
import { AnswerBoolean } from './AnswerBoolean.tsx'
import { AnswerChoices } from './AnswerChoices.tsx'
import { AnswerMultiSelect } from './AnswerMultiSelect.tsx'
import { AnswerNumber } from './AnswerNumber.tsx'

export const OrderDetailsAnswers = ({
  orderDetails,
  horizontal = false
}: {
  orderDetails: OrderDetailsType
  horizontal?: boolean
}) => {

  return (
    <div className={classNames('list-disc marker:text-gray-300 mb-4 pl-0 md:pl-4')}>
      {orderDetails.questions.map((question) => {
        switch (question.question_type) {
          case 'NUMBER':
            return <AnswerNumber key={question.id} question={question} horizontal={horizontal} />

          case 'BOOLEAN':
            return <AnswerBoolean key={question.id} question={question} horizontal={horizontal} />

          case 'CHOICES':
            return <AnswerChoices key={question.id} question={question} horizontal={horizontal}/>

          case 'MULTI_SELECT':
            return <AnswerMultiSelect key={question.id} question={question} horizontal={horizontal}/>

          default:
            return <div></div>
        }
      })}
    </div>
  )
}
